<template>
    <div class="layout">
        <div style="text-align:right;">
            <Button type="primary" @click="resetReport" :loading="loading">{{ $t('清除') }}</Button>
            &nbsp;&nbsp;
            <Button type="primary" :loading="loading" @click="createReport">{{ $t('维护批次出货检验报告') }}</Button>
        </div>
        <Form :label-width="110" style="margin-top:20px;" :model="reportObj" ref="reportForm" :rules="reportRules">
            <Row>
                <Col :span="8">
                    <FormItem :label="$t('事业部')" prop="buId">
                       <Select v-model="reportObj.buId"
                               size="small"
                               @on-change="buChange" 
                        >
                            <Option v-for="(item, key) in buidList" 
                                :key="key" 
                                :value="item.value"
                            >{{item.label}}</Option>
                       </Select>
                    </FormItem>
                </Col>
                <Col :span="8">
                    <FormItem :label="$t('物料编码')" prop="itemCode">
                        <Input v-model="reportObj.itemCode" 
                                icon="search"
                                size="small"
                                :disabled="loading"
                                @on-click="itemCodeSearch"
                                @on-blur="handleSearch">
                        </Input>
                    </FormItem>
                </Col>
                <Col :span="8">
                    <FormItem :label="$t('物料描述')" prop="itemDesc">
                       <Input v-model="reportObj.itemDesc" size="small" :title="reportObj.itemDesc" readonly></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col :span="8">
                    <FormItem :label="$t('批次号')" prop="batchNumber">
                       <Input v-model="reportObj.batchNumber" size="small"></Input>
                    </FormItem>
                </Col>
                <Col :span="8">
                    <FormItem :label="$t('检验员')" prop="checker">
                       <Input v-model="reportObj.checker" size="small"></Input>
                    </FormItem>
                </Col>
                <Col :span="8">
                    <FormItem :label="$t('生产数量')" prop="checkQuantity">
                        <Input-number v-model="reportObj.checkQuantity" size="small" style="width:100%"></Input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col :span="8">
                    <FormItem :label="$t('产地-品牌')" prop="placeBrand">
                       <Input v-model="reportObj.placeBrand" size="small"></Input>
                    </FormItem>
                </Col>
                <Col :span="8">
                    <FormItem :label="$t('有效日期')" required>
                        <Row>
                            <Col span="11">
                                <FormItem label="" prop="validStartTime">
                                    <DatePicker 
                                        v-model="reportObj.validStartTime" 
                                        type="datetime"
                                        transfer
                                        disabled
                                        format="yyyy/MM/dd HH:mm:ss"
                                        size="small"
                                        style="width:100%"
                                        :options="dataOptions"
                                    />
                                </FormItem>
                            </Col>
                            <Col span="2" style="text-align:center;">
                            -
                            </Col>
                            <Col span="11">
                                <FormItem label="" prop="validEndTime">
                                    <DatePicker
                                        v-model="reportObj.validEndTime" 
                                        type="datetime"
                                        transfer
                                        disabled
                                        format="yyyy/MM/dd 23:59:59"
                                        size="small"
                                        style="width:100%"
                                        :options="dataOptions"
                                    />
                                </FormItem>
                            </Col>
                        </Row>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <!--物料编码-->
        <Modal
            v-model="modal1"
            :mask-closable="false"
            :title="$t('物料编码')"
            :loading="loading"
            :closable="false"
            :styles="{top: '20px', zIndex: 1002}"
            @on-ok="itemOnOk"
            width="650">
            <Form ref="formValidate" :model="formValidate" :label-width="100">
                <Row :gutter="16">
                    <Col span="20">
                        <FormItem :label="$t('物料编码')" prop="itemCode">
                          <Input v-model="formValidate.itemCode"></Input>
                        </FormItem>
                    </Col>
                    <Col span="4">
                        <Button type="primary" @click="handleSearch(false)">{{ $t('查询') }}</Button>
                    </Col>
                </Row>
            </Form>
            <Table :loading="loading" border :columns="columns" height="300" highlight-row ref="currentRowTable" :data="data" @on-current-change="handleCurrentChange"></Table>
            <div class="pagination" style="margin-top:10px;">
                <Page :total="total" :current="current" @on-change="handlePageChange"></Page>
            </div>
        </Modal>
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
export default {
    name: 'outgoingInspectionReportAdd',
    data () {
        const validateBatchNumber = (rule, value, callback) => {
            if (!this.reportObj.batchNumber) {
                callback(this.$t('批次号不能为空'));
            } else {
                const len = value.replace(/[^\x00-\xff]/g, '011').length;
                if (len > 240) { // 限制240字节
                    callback(new Error(this.$t('批次号超长，请缩短内容')));
                }
            }
            callback();
        }
        const validateChecker = (rule, value, callback) => {
            if (!this.reportObj.checker) {
                callback(this.$t('检验员不能为空'));
            } else {
                const len = value.replace(/[^\x00-\xff]/g, '011').length; // 替换三字节字符（utf-8）
                if (len > 80) { // 限制80字节
                    callback(new Error(this.$t('检验员超长，请缩短内容')));
                }
            }
            callback();
        }
        const validatePlaceBrand = (rule, value, callback) => {
            if (!this.reportObj.placeBrand) {
                callback(this.$t('产地品牌不能为空'));
            } else {
                const len = value.replace(/[^\x00-\xff]/g, '011').length;
                if (len > 240) { // 限制240字节
                    callback(new Error(this.$t('【产地-品牌】超长，请缩短内容')));
                }
            }
            callback();
        }
        return {
            chooseItem: {},
            reportObj: {
                buId: '',
                buCode: '',
                buName: '',
                itemCode: '',
                itemDesc: '',
                itemUnit: '',
                batchNumber: '',
                checker: '',
                checkQuantity: null,
                placeBrand: '',
                validStartTime: '',
                validEndTime: ''
            },
            reportRules: {
                buId: [
                    { required: true, message: this.$t('事业部不能为空'), trigger: 'change' }
                ],
                itemCode: [
                    { required: true, message: this.$t('物料编码不能为空'), trigger: 'change' }
                ],
                batchNumber: [
                    { required: true, message: this.$t('批次号不能为空'), trigger: 'blur' },
                    { validator: validateBatchNumber, trigger: 'blur' }
                ],
                checker: [
                    { required: true, message: this.$t('检验员不能为空'), trigger: 'blur' },
                    { validator: validateChecker, trigger: 'blur' }
                ],
                checkQuantity: [
                    { required: true, type: 'number', message: this.$t('生产数量不能为空'), trigger: 'blur' }
                ],
                placeBrand: [
                    { required: true, message: this.$t('产地品牌不能为空'), trigger: 'blur' },
                    { validator: validatePlaceBrand, trigger: 'blur' }
                ],
                validStartTime: [
                    { required: true, type: 'date', message: this.$t('请输入开始日期') }
                ],
                validEndTime: [
                    { required: true, type: 'date', message: this.$t('请输入结束日期') }
                ]
            },
            buidList: [],
            modal1: false,
            loading: false,
            formValidate: {
                itemCode: ''
            },
            columns: [
                {
                    title: this.$t('物料编码'),
                    key: 'itemCode',
                    width: 150
                },
                {
                    title: this.$t('物料描述'),
                    key: 'itemDesc'
                },
                {
                    title: this.$t('单位'),
                    key: 'unit',
                    width: 100
                }
            ],
            data: [],
            total: 0,
            current: 1,
            dataOptions: {
                disabledDate (date) {
                    return date && date.valueOf() < Date.now() - 86400000;
                }
            },
            pageNum: 1,
            pageSize: 10,
        };
    },
    methods: {
        buChange(value){
            let buRow = this.buidList.find(item => item.qmsId === value);
            console.log('buRow', buRow)
            this.reportObj.buName = buRow.buName;
            this.reportObj.buCode = buRow.buCode;
        },
        itemOnOk () {
            this.reportObj.itemCode = this.chooseItem.itemCode;
            this.reportObj.itemDesc = this.chooseItem.itemDesc;
            this.reportObj.itemUnit = this.chooseItem.unit;
            this.validEndTimeHandle(this.chooseItem.effectiveTime);
        },
        validEndTimeHandle (time) {
            if (time) {
                this.reportObj.validEndTime = new Date(moment().add(time, 'd'));
            } else {
                this.showErrorTips('loading', this.$t('请先联系美的配套人员维护采购大类的有效天数’，不能进行下一步处理'));
            }
        },
        handleCurrentChange (row) {
            this.chooseItem = row;
        },
        handlePageChange (pageNum) {
            this.pageNum = pageNum;
            this.handleSearch();
        },
        createReport () {
            this.$refs.reportForm.validate((valid) => {
                if (valid) {
                    this.loading = false;
                    // 跳转到维护之间报告页面
                    sessionStorage.setItem('outgoingInspectionReportAdd', JSON.stringify({
                        ...this.reportObj
                    }));
                    this.$router.push({
                        path: '/qualityManagement/shipmentInspectionAdd',
                        query: {
                            buId: this.reportObj.buId,
                            checkQuantity: this.reportObj.checkQuantity,
                            itemCode: this.reportObj.itemCode.replace(/\s+/g, '')
                        }
                    });
                    this.resetReport();
                }
            });
        },
        queryBu () {
            axios.get('/gscint/vendor/getOverSeaBuList', {
                params: {
                    SITE: 'Y',
                    ASL: 'N'
                }
            })
            .then((res) => {
                let resData = res.data.data
                this.buidList = []
                if (resData.code == '1') {
                    const data = resData.datas || []
                    data.forEach((item) => {
                        item['label'] = item.buName;
                        item['value'] = item.qmsId;
                    });
                    this.buidList = data;
                }
            });
        },
        // 物料编码查询
        handleSearch (itemCode) {
            this.loading = true;
            axios.post('/gscint/sxInspection/queryItemList', {
                buCode: this.reportObj.buCode,
                itemCode: itemCode ? this.reportObj.itemCode.replace(/\s+/g, '') : this.formValidate.itemCode.replace(/\s+/g, ''),
                vendorCode: this.vendorCode,
                pageIndex: this.pageNum,
                pageSize: this.pageSize
            })
            .then((res) => {
                this.loading = false;
                let resData = res.data.data
                console.log('querySxInspectionReportDetail', resData)
                if (resData.code == '1') {
                    let itemData = resData.datas.list || []
                    this.total = resData.datas.total
                    if (itemData.length > 0) {
                        if (this.reportObj.itemCode) {
                            this.reportObj.itemDesc = itemData[0].itemDesc;
                            this.reportObj.itemUnit = itemData[0].unit;
                            this.validEndTimeHandle(itemData[0].effectiveTime);
                        }
                        this.data = itemData;
                    } else {
                        this.showErrorTips('loading', this.$t('此物料不是此事业部的批准物料，请重新输入'));
                        this.reportObj.itemUnit = '';
                        this.reportObj.itemDesc = '';
                        this.reportObj.validEndTime = '';
                    }
                } else {
                    this.showErrorTips('loading', this.$t('此物料不是此事业部的批准物料，请重新输入'));
                    this.reportObj.itemUnit = '';
                    this.reportObj.itemDesc = '';
                    this.reportObj.validEndTime = '';
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        itemCodeSearch () {
            this.$refs.reportForm.validateField('buId');
            if (this.reportObj.buId) {
                this.modal1 = true;
                this.handleSearch(false)
            }
        },
        resetReport () {
            this.$refs.reportForm.resetFields();
            this.reportObj.validStartTime = new Date(moment().format('YYYY/MM/DD 00:00:00'));
        },
    },
    mounted () {
        this.queryBu();
        this.reportObj.validStartTime = new Date(moment().format('YYYY/MM/DD 00:00:00'));
    }
};
</script>
<style lang="less" scoped>
.layout {
  background: #FFF;
  padding: 20px 50px 0 20px;
  min-height: 400px;
}
.title-bar {
    background-color: #F2F2F2;
    border: 1px solid #dddee1;
    padding: 10px 20px;
    button {
        float: right;
    }
    span {
        border-left: 5px solid #3AA2EB;
        padding: 0 7px;
        font-size: 15px;
        font-weight: 400;
        height: 32px;
        line-height: 32px;
    }
}
</style>